import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LandingPage } from "../../pages/LandingPage";

export function HomeRoute() {
  const { user, isGuest, loading } = useAuth();

  if (loading) return null;

  if (isGuest) return <LandingPage />;                  // гость, вошедший кнопкой «гость»
  if (user) return <Navigate to="/dashboard" replace />; // залогиненный
  return <Navigate to="/login" replace />;               // все остальные
}